import script from "./SilentBoxOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./SilentBoxOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./SilentBoxOverlay.vue?vue&type=style&index=0&id=cae3df42&lang=scss"

const __exports__ = script;

export default __exports__